export function getSpotifyAuthorizeHref(subscriberId: string, redirectPath?: string): string {
  const searchParams = new URLSearchParams({ subscriber_id: subscriberId });

  if (redirectPath) {
    searchParams.set('redirect_path', redirectPath);
  }

  return `/oauth/spotify/authorize?${searchParams.toString()}`;
}

export function getPodcastHref({ showId, subscriberId }: { showId: string; subscriberId: string }): string {
  return `/subscribe/${subscriberId}/podcasts/${showId}`;
}
